import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataPainEndoModel} from '../../../pain/models/data-pain-endo.model';
import {StaticDataService} from '../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';

@Component({
  standalone: false,
  selector: 'app-pain-history-sleuth-wizard-dialog',
  templateUrl: './pain-history-sleuth-wizard-dialog.component.html',
  styleUrls: ['./pain-history-sleuth-wizard-dialog.component.scss']
})
export class PainHistorySleuthWizardDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DataPainEndoModel,
              private staticDataService: StaticDataService,
              private dialogRef: MatDialogRef<PainHistorySleuthWizardDialogComponent>) { }

  sleuthBEnums: EnumValidValueItemModel[] = [];
  sleuthLEnums: EnumValidValueItemModel[] = [];
  sleuthMBEnums: EnumValidValueItemModel[] = [];
  sleuthMLEnums: EnumValidValueItemModel[] = [];
  sleuthDBEnums: EnumValidValueItemModel[] = [];
  sleuthDLEnums: EnumValidValueItemModel[] = [];

  ngOnInit(): void {
    console.log(this.data);
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    }
  }

  setupEnums() {
    this.sleuthBEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainToothSleuthX');
    /*this.sleuthLEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainToothSleuthX');
    this.sleuthMBEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainToothSleuthMB');
    this.sleuthMLEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainToothSleuthML');
    this.sleuthDBEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainToothSleuthDB');
    this.sleuthDLEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainToothSleuthDL');*/
  }

  onCancelClick() {
      this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.data);
  }

  isSelected(enu: EnumValidValueItemModel, t: string) {
    switch (t) {
      case 'B':
        return this.data.enumEndoPainToothSleuthBID?.toLowerCase() === enu.ValidValueItemId.toLowerCase();
      case 'L':
        return this.data.enumEndoPainToothSleuthLID?.toLowerCase() === enu.ValidValueItemId.toLowerCase();
      case 'MB':
        return this.data.enumEndoPainToothSleuthMBID?.toLowerCase() === enu.ValidValueItemId.toLowerCase();
      case 'ML':
        return this.data.enumEndoPainToothSleuthMLID?.toLowerCase() === enu.ValidValueItemId.toLowerCase();
      case 'DB':
        return this.data.enumEndoPainToothSleuthDBID?.toLowerCase() === enu.ValidValueItemId.toLowerCase();
      case 'DL':
        return this.data.enumEndoPainToothSleuthDLID?.toLowerCase() === enu.ValidValueItemId.toLowerCase();
    }
  }
}
